import styled, { css } from 'styled-components'

const title = css`
  color: #43454f;
  font-weight: bold;
  font-size: 17px;
  margin-left: 15px;
`

export const StyledLonBuybackContainer = styled.section`
  margin-top: 45px;
  .title {
    ${title}
  }
`

export const StyledBuybackContainer = styled.div`
  display: flex;
  gap: 30px;

  .data-container {
    flex: 1;
    padding: 20px 30px;
    max-width: 378px;
  }
  @media screen and (max-width: 640px) {
    flex-direction: column;
    gap: 0;

    .data-container {
      .content {
        font-size: 21px;
      }
    }
  }
`
